<div class="page">
  <header class="page-header">
    <div class="header-text">
      <h1>Active Challenges</h1>
      <p class="subtitle">Submit ideas to challenges and earn bonus points!</p>
    </div>
    <button *ngIf="canManageChallenges" type="button" class="btn-add" (click)="openAddModal()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
      </svg>
      Add Challenge
    </button>
  </header>

  <div *ngIf="errorMessage" class="error-banner" role="alert">{{ errorMessage }}</div>
  <div *ngIf="loading" class="loading-state">
    <app-loader label="Loading challenges"></app-loader>
  </div>

  <div *ngIf="!loading && challenges.length === 0" class="empty-state">
    <p>No challenges yet.</p>
    <p class="empty-hint">Create a challenge to get started.</p>
    <button *ngIf="canManageChallenges" type="button" class="btn-primary" (click)="openAddModal()">Add Challenge</button>
  </div>

  <div class="challenges-grid" *ngIf="!loading && challenges.length > 0">
    <article *ngFor="let c of challenges" class="challenge-card">
      <div class="card-top">
        <span class="trophy-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
            <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zm-2 2v1c0 1.1-.9 2-2 2h-2V7h4zM9 7v3H7c-1.1 0-2-.9-2-2V7h4zm2 12v-4h2v4h-2zm-2 0v-4H7v4h2z"/>
          </svg>
        </span>
        <div class="card-top-right">
          <span class="points-badge">{{ c.points }} points</span>
          <div *ngIf="canManageChallenges" class="overflow-menu-wrapper">
            <button type="button" class="btn-overflow" (click)="toggleMenu(c); $event.stopPropagation()" [attr.aria-expanded]="openMenuId === c.id" aria-label="More options">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </button>
            <div *ngIf="openMenuId === c.id" class="overflow-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="overflow-item" (click)="openEditModal(c)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                Edit
              </button>
              <button type="button" class="overflow-item overflow-item-danger" (click)="deleteChallenge(c)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <h3 class="challenge-title">{{ c.title }}</h3>
      <p class="challenge-overview">{{ c.overview }}</p>
      <div class="card-meta">
        <span class="meta-item">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
          </svg>
          {{ formatDeadline(c.deadlineUtc) }}
        </span>
        <span class="meta-item">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
          </svg>
          {{ c.ideasCount }} ideas
        </span>
      </div>
      <div class="card-actions">
        <a [routerLink]="['/submit-idea']" [queryParams]="{ challengeId: c.id }" [queryParamsHandling]="'merge'" class="btn-submit">Submit to Challenge</a>
        <button type="button" class="btn-details" (click)="openViewDetails(c)">View Details</button>
      </div>
    </article>
  </div>
</div>

<!-- Add Challenge Modal -->
<div *ngIf="showAddModal && canManageChallenges" class="modal-overlay" (click)="closeAddModal()" role="dialog" aria-modal="true" aria-labelledby="modal-title">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 id="modal-title">{{ editingChallengeId ? 'Edit Challenge' : 'Add Challenge' }}</h2>
      <button type="button" class="modal-close" (click)="closeAddModal()" aria-label="Close">&times;</button>
    </div>
    <form [formGroup]="addForm" (ngSubmit)="saveChallenge()" class="modal-form">
      <div class="form-group">
        <label for="challenge-title">Challenge Title <span class="required">*</span></label>
        <input id="challenge-title" type="text" formControlName="title" placeholder="e.g. Sustainability Champions" />
        <span *ngIf="addForm.get('title')?.touched && addForm.get('title')?.errors?.['required']" class="error">Title is required.</span>
        <span *ngIf="addForm.get('title')?.touched && addForm.get('title')?.errors?.['minlength']" class="error">Title must be at least 3 characters.</span>
      </div>
      <div class="form-group">
        <label for="challenge-overview">Challenge Overview <span class="required">*</span></label>
        <textarea id="challenge-overview" formControlName="overview" rows="4" placeholder="Describe the challenge and what you're looking for..."></textarea>
        <span *ngIf="addForm.get('overview')?.touched && addForm.get('overview')?.errors?.['required']" class="error">Overview is required.</span>
        <span *ngIf="addForm.get('overview')?.touched && addForm.get('overview')?.errors?.['minlength']" class="error">Overview must be at least 10 characters.</span>
      </div>
      <div class="form-group">
        <label for="challenge-deadline">Deadline <span class="required">*</span></label>
        <input id="challenge-deadline" type="date" formControlName="deadline" />
        <span *ngIf="addForm.get('deadline')?.touched && addForm.get('deadline')?.errors?.['required']" class="error">Deadline is required.</span>
      </div>
      <div class="form-group">
        <label for="challenge-points">Points Reward <span class="required">*</span></label>
        <input id="challenge-points" type="number" formControlName="pointsReward" min="1" max="10000" placeholder="e.g. 500" />
        <span *ngIf="addForm.get('pointsReward')?.touched && addForm.get('pointsReward')?.invalid" class="error">Enter a valid number (1–10000).</span>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn-cancel" (click)="closeAddModal()">Cancel</button>
        <button type="submit" class="btn-save" [disabled]="addForm.invalid">{{ editingChallengeId ? 'Save Changes' : 'Add Challenge' }}</button>
      </div>
    </form>
  </div>
</div>

<!-- View Details Modal -->
<div *ngIf="showViewDetailsModal && selectedChallenge" class="modal-overlay view-details-overlay" (click)="closeViewDetails()" role="dialog" aria-modal="true" [attr.aria-labelledby]="'view-details-title'">
  <div class="view-details-modal" (click)="$event.stopPropagation()">
    <div class="view-details-header">
      <div class="view-details-title-row">
        <span class="trophy-icon-large">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
            <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zm-2 2v1c0 1.1-.9 2-2 2h-2V7h4zM9 7v3H7c-1.1 0-2-.9-2-2V7h4zm2 12v-4h2v4h-2zm-2 0v-4H7v4h2z"/>
          </svg>
        </span>
        <h2 id="view-details-title" class="view-details-title">{{ selectedChallenge.title }}</h2>
      </div>
      <button type="button" class="modal-close" (click)="closeViewDetails()" aria-label="Close">&times;</button>
    </div>

    <div class="view-details-body">
      <section class="details-section">
        <h3 class="section-heading">Challenge Overview</h3>
        <p class="section-text">{{ selectedChallenge.overview }}</p>
      </section>

      <div class="details-meta-row">
        <span class="details-meta-item">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
          </svg>
          Deadline: {{ formatDeadlineShort(selectedChallenge.deadlineUtc) }}
        </span>
        <span class="details-meta-item reward">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2z"/>
          </svg>
          {{ selectedChallenge.points }} points reward
        </span>
      </div>

      <section class="ideas-section">
        <h3 class="section-heading">Submitted Ideas ({{ selectedChallenge.ideasCount }})</h3>
        <div *ngIf="loadingIdeas" class="loading-ideas">
          <app-loader label="Loading ideas for this challenge" [inline]="true" size="sm"></app-loader>
        </div>
        <div *ngIf="!loadingIdeas && !selectedChallengeIdeas.length" class="no-ideas">No ideas submitted yet. Be the first to submit!</div>
        <div class="idea-cards" *ngIf="!loadingIdeas && selectedChallengeIdeas.length">
          <article *ngFor="let idea of selectedChallengeIdeas" class="idea-card">
            <a [routerLink]="['/ideas', idea.id]" class="idea-card-link">
              <h4 class="idea-card-title">{{ idea.title }}</h4>
              <p class="idea-card-desc">{{ idea.description || '' }}</p>
              <div class="idea-card-footer">
                <span class="idea-author">by {{ idea.ownerDisplayName || 'Anonymous' }}</span>
                <span class="idea-stats">
                  <span class="stat"><svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg> {{ idea.upvoteCount ?? 0 }}</span>
                  <span class="stat"><svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/></svg> {{ idea.commentCount ?? 0 }}</span>
                </span>
              </div>
            </a>
          </article>
        </div>
      </section>
    </div>
  </div>
</div>
